var Vue = require('vue');
var DataTable = require('./datatable.js');
var ExportActionDropdown = require('./components/Exports/ExportActionDropdown.vue').default;
var SavedViewsList = require('./../modules/search/components/SavedViewsList').default;
var SaveViewForm = require('./../modules/search/components/SaveViewForm').default;
var store = require('./../lib/store').default;

/**
 * Setup base components on the index view.
 *
 * Usage:
 *   new IndexView();
 *
 */
module.exports = function () {
  var datatable = new DataTable;

  datatable.setup('.datatable');

  let savedViewsList, saveViewForm;

  $('.filtertron-tray').filtertronTray({
    onOpen: function () {
      datatable.refresh();

      if (!savedViewsList && !saveViewForm) {
        saveViewForm = new Vue({
          el: '.save-view-form',
          components: {
            SaveViewForm
          },
          store
        });

        savedViewsList = new Vue({
          el: '.saved-searches',
          components: {
            SavedViewsList
          },
          store
        });

        $(document).one('pjax:end', () => {
          saveViewForm.$destroy();
          savedViewsList.$destroy();
        });
      }
    },
    onClose: function () {
      datatable.refresh();
    }
  });

  $(document).one('pjax:end', () => {
    datatable.refresh();
  });

  var exportActionButton = document.getElementById('export-action');

  if (exportActionButton) {
    new Vue({
      el: exportActionButton,
      components: {
        'export-action-dropdown': ExportActionDropdown
      }
    });
  }
};
